import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';
import { SemCreativeCardV1Component } from '../sem-creative-card-v1/sem-creative-card-v1.component';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';

@Component({
	selector: 'app-sem-creative-card-v3',
	templateUrl: './sem-creative-card-v3.component.html',
	styleUrls: ['./sem-creative-card-v3.component.css']
})
export class SemCreativeCardV3Component extends SemCreativeCardV1Component implements OnInit, OnDestroy {
	@ViewChild('carousel') carousel: NguCarousel<any>;
	public carouselOne: NguCarouselConfig;
	@Input() datatableconfig;

	public devicedatatableconfig;
	public carouselItemWidth;
	public dotsHeight;
	private carouselToken: string;

	constructor(protected analyticsService: AnalyticsService) {
		super(analyticsService);
		this.carouselOne = {
			grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
			loop: true,
			touch: true,
			velocity: 0.2,
			point: {
				visible: true,
				hideOnSingleSlide: true
			}
		};
	}

	ngOnInit() {
		this.datatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		super.ngOnInit();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	processResponseData(responseData) {
		if (responseData.length > 0) {
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
		} else {
			this.hasData = false;
		}
	}

	initDataFn(e) {
		this.carouselItemWidth = e.itemWidth;
		this.carouselToken = e.token;
	}

	resetFn() {
		this.carousel.reset();
	}

	getSlideIndex(row) {
		for (let i = 0; i < this.creatives.length; i++) {
			if (
				this.creatives[i].description === row.description &&
				this.creatives[i].ad_headline === row.ad_headline &&
				this.creatives[i].impressions === row.impressions
			) {
				return i;
			}
		}
	}

	scrollToSlide(row) {
		const indexOfAd = this.getSlideIndex(row);
		this.carousel.moveTo(indexOfAd, false);
	}
}
